import type { NumericCondition, SetCondition, V2PayloadCondition } from '../../../ProgramStateMachine.types'

import type { V2ConditionFormValue } from './transitionV2FormValues'

const parseValueToken = (raw: string): string | number | boolean => {
  const trimmed = raw.trim()

  if (trimmed === 'true') return true

  if (trimmed === 'false') return false

  if (trimmed !== '' && !Number.isNaN(Number(trimmed))) return Number(trimmed)

  return trimmed
}

export const parseValuesText = (valuesText: string): (string | number | boolean)[] =>
  valuesText
    .split(',')
    .map(v => v.trim())
    .filter(v => v.length > 0)
    .map(parseValueToken)

export const joinValues = (values: (string | number | boolean)[]): string => values.map(v => String(v)).join(', ')

export const toConditionFormValue = (c: V2PayloadCondition): V2ConditionFormValue => {
  if ('values' in c) {
    return {
      type: 'set',
      key: c.key,
      valuesText: joinValues(c.values),
      isOneOf: c.isOneOf ?? true,
      numericValue: '',
      numericOperator: '=='
    }
  }

  return {
    type: 'numeric',
    key: c.key,
    valuesText: '',
    isOneOf: true,
    numericValue: String(c.value),
    numericOperator: c.operator
  }
}

export const fromConditionFormValue = (c: V2ConditionFormValue): V2PayloadCondition | null => {
  if (c.key.trim() === '') return null

  if (c.type === 'numeric') {
    const parsed = Number(c.numericValue)

    if (c.numericValue.trim() === '' || Number.isNaN(parsed)) return null
    const cond: NumericCondition = { key: c.key, value: parsed, operator: c.numericOperator }

    return cond
  }

  const values = parseValuesText(c.valuesText)

  if (values.length === 0) return null
  const cond: SetCondition = { key: c.key, values, isOneOf: c.isOneOf }

  return cond
}
